// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.107.2_postcss@8.5.15_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.107.2_postcss@8.5.15_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  height: 100%;
  margin: 0;
}

body {
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  background: #f5f7fb;
}

.editor-shell {
  min-height: 100%;
}

.panel {
  border-right: 1px solid #e5e7eb;
  padding: 20px;
  overflow: auto;
}

.panel:last-child {
  border-left: 1px solid #e5e7eb;
  border-right: 0;
}

.canvas-column {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.toolbar {
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
}

.toolbar h4 {
  margin: 0;
}

.palette {
  display: grid;
  gap: 20px;
}

.material-list {
  display: grid;
  gap: 10px;
  margin-top: 10px;
}

.material-card {
  align-items: center;
  background: #fff;
  border: 1px solid #d9dce3;
  border-radius: 8px;
  cursor: grab;
  display: flex;
  gap: 10px;
  min-height: 44px;
  padding: 10px 12px;
  text-align: left;
}

.material-icon {
  background: #eef4ff;
  border-radius: 6px;
  color: #2454c6;
  min-width: 44px;
  padding: 4px 6px;
  text-align: center;
}

.canvas {
  background: #fff;
  border: 1px dashed #c8d0df;
  border-radius: 8px;
  flex: 1;
  margin: 24px;
  min-height: 520px;
  overflow: auto;
  padding: 24px;
}

.canvas.is-over {
  border-color: #1677ff;
  box-shadow: inset 0 0 0 2px rgba(22, 119, 255, 0.12);
}

.canvas-node {
  border: 1px solid transparent;
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 16px;
  position: relative;
}

.canvas-node:hover {
  border-color: #91caff;
}

.canvas-node.is-selected {
  border-color: #1677ff;
  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.14);
}

.canvas-node.is-container-node {
  border-style: dashed;
}

.canvas-node.is-over-node {
  border-color: #52c41a;
  box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.16);
}

.node-tag {
  background: #1677ff;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  left: 10px;
  line-height: 20px;
  opacity: 0;
  padding: 0 6px;
  position: absolute;
  top: -10px;
}

.canvas-node:hover .node-tag,
.canvas-node.is-selected .node-tag {
  opacity: 1;
}

.lc-material-skeleton,
.lc-material-error {
  border: 1px dashed #d9dce3;
  border-radius: 8px;
  color: #667085;
  padding: 16px;
}

.lc-material-error {
  background: #fff2f0;
  border-color: #ffccc7;
  color: #a8071a;
  display: grid;
  gap: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;;EAGE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,6EAA6E;EAC7E,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,QAAQ;AACV","sourcesContent":["html,\nbody,\n#root {\n  height: 100%;\n  margin: 0;\n}\n\nbody {\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  background: #f5f7fb;\n}\n\n.editor-shell {\n  min-height: 100%;\n}\n\n.panel {\n  border-right: 1px solid #e5e7eb;\n  padding: 20px;\n  overflow: auto;\n}\n\n.panel:last-child {\n  border-left: 1px solid #e5e7eb;\n  border-right: 0;\n}\n\n.canvas-column {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.toolbar {\n  align-items: center;\n  background: #fff;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  justify-content: space-between;\n  padding: 16px 24px;\n}\n\n.toolbar h4 {\n  margin: 0;\n}\n\n.palette {\n  display: grid;\n  gap: 20px;\n}\n\n.material-list {\n  display: grid;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.material-card {\n  align-items: center;\n  background: #fff;\n  border: 1px solid #d9dce3;\n  border-radius: 8px;\n  cursor: grab;\n  display: flex;\n  gap: 10px;\n  min-height: 44px;\n  padding: 10px 12px;\n  text-align: left;\n}\n\n.material-icon {\n  background: #eef4ff;\n  border-radius: 6px;\n  color: #2454c6;\n  min-width: 44px;\n  padding: 4px 6px;\n  text-align: center;\n}\n\n.canvas {\n  background: #fff;\n  border: 1px dashed #c8d0df;\n  border-radius: 8px;\n  flex: 1;\n  margin: 24px;\n  min-height: 520px;\n  overflow: auto;\n  padding: 24px;\n}\n\n.canvas.is-over {\n  border-color: #1677ff;\n  box-shadow: inset 0 0 0 2px rgba(22, 119, 255, 0.12);\n}\n\n.canvas-node {\n  border: 1px solid transparent;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  padding: 16px;\n  position: relative;\n}\n\n.canvas-node:hover {\n  border-color: #91caff;\n}\n\n.canvas-node.is-selected {\n  border-color: #1677ff;\n  box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.14);\n}\n\n.canvas-node.is-container-node {\n  border-style: dashed;\n}\n\n.canvas-node.is-over-node {\n  border-color: #52c41a;\n  box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.16);\n}\n\n.node-tag {\n  background: #1677ff;\n  border-radius: 4px;\n  color: #fff;\n  font-size: 12px;\n  left: 10px;\n  line-height: 20px;\n  opacity: 0;\n  padding: 0 6px;\n  position: absolute;\n  top: -10px;\n}\n\n.canvas-node:hover .node-tag,\n.canvas-node.is-selected .node-tag {\n  opacity: 1;\n}\n\n.lc-material-skeleton,\n.lc-material-error {\n  border: 1px dashed #d9dce3;\n  border-radius: 8px;\n  color: #667085;\n  padding: 16px;\n}\n\n.lc-material-error {\n  background: #fff2f0;\n  border-color: #ffccc7;\n  color: #a8071a;\n  display: grid;\n  gap: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
